var _rect, _rect2, _ellipse, _rect3, _rect4, _rect5, _ellipse2, _rect6, _rect7, _rect8, _ellipse3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHousingProtectServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 142,
    viewBox: "0 0 175 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.7129,
    y: 54.1719,
    width: 112.385,
    height: 21.0323,
    rx: 10.5162,
    transform: "rotate(-13.259 24.7129 54.1719)",
    fill: "#EEC2B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.13281,
    y: 73.3252,
    width: 98.3201,
    height: 29.3899,
    rx: 14.695,
    transform: "rotate(-48.259 1.13281 73.3252)",
    fill: "#EEC2B9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.9987,
    cy: 90.1554,
    rx: 42.0647,
    ry: 44.6937,
    transform: "rotate(-13.259 43.9987 90.1554)",
    fill: "#EEC2B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.75,
    y: 67.0537,
    width: 65.6582,
    height: 70.8975,
    rx: 17,
    transform: "rotate(-13.259 27.75 67.0537)",
    fill: "#EEC2B9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7129,
    y: 48.1719,
    width: 112.385,
    height: 21.0323,
    rx: 10.5162,
    transform: "rotate(-13.259 23.7129 48.1719)",
    fill: "#FFDCD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.132812,
    y: 67.3252,
    width: 98.3201,
    height: 29.3899,
    rx: 14.695,
    transform: "rotate(-48.259 0.132812 67.3252)",
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9987,
    cy: 84.1554,
    rx: 42.0647,
    ry: 44.6937,
    transform: "rotate(-13.259 42.9987 84.1554)",
    fill: "#FFDCD5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.75,
    y: 61.0537,
    width: 65.6582,
    height: 70.8975,
    rx: 17,
    transform: "rotate(-13.259 26.75 61.0537)",
    fill: "#FFDCD5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 118.592,
    y: 94.3418,
    width: 55.8813,
    height: 46.7461,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 143.072,
    y: 111.917,
    width: 6.9176,
    height: 19.5735,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.534,
    cy: 111.917,
    rx: 7.97724,
    ry: 7.97724,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.033 100.355V77C130.033 72.0294 134.063 68 139.033 68H154.032C159.002 68 163.032 72.0294 163.032 77V100.355",
    stroke: "#D9D9D9",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHousingProtectServiceBody);
export default __webpack_public_path__ + "static/media/IcHousingProtectServiceBody.9bedc17dc7d76b79b6cbc899eaeb6823.svg";
export { ForwardRef as ReactComponent };